import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoonOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M14.165 7.874a4.333 4.333 0 0 1-6.04-6.04H8a6.167 6.167 0 1 0 6.165 6.04"
	})
});
export default SvgMoonOutlined;
